export default function Menu() {
    document.addEventListener('DOMContentLoaded', function() {
        // general functions
        changeMenuInnerPages();
        handleMenuOnScroll();

        document.addEventListener('scroll', toggleWhatsappBtn);

        // desktop + mobile sempre vinculados: decidir uma única vez por
        // window.innerWidth quebrava o menu quando o viewport mudava depois
        // do load (rotação/resize) ou quando o DOMContentLoaded disparava
        // antes do layout estabilizar (variava por página e navegador).
        // Os elementos do modo "errado" ficam com display:none e não são clicáveis.
        handleMenuDropdownOpening();
        handleLanguagesDropdown();

        // show products on menu desktop
        document.querySelectorAll('#categories .product-item').forEach(item => {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                showMenuProducts(this);
            });
        });

        // back to categories on menu desktop
        const backToCategoriesBtn = document.getElementById('backToCategories');

        if (backToCategoriesBtn) {
            backToCategoriesBtn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                showMenuCategories();
            });
        }

        handleMenuMobile();
        ajustMenuCategoriesDisplay();

        // show products offcanvas mobile
        document.querySelectorAll('#menuCategoriesMobile .product-item').forEach(item => {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                changeProductTitleMobile(this);
            });
        });
    })

    function handleMenuDropdownOpening() {
        const toggler = document.getElementById('toggleProducts');
        const menu = document.getElementById('dropdownProducts');

        if (!toggler || !menu) return;

        function openMenu() {
            toggler.classList.add('show');
            toggler.setAttribute('aria-expanded', 'true');

            menu.classList.add('show');
            menu.setAttribute('aria-expanded', 'true');
            menu.setAttribute('aria-hidden', 'false');
        }

        function closeMenu() {
            toggler.classList.remove('show');
            toggler.setAttribute('aria-expanded', 'false');

            menu.classList.remove('show');
            menu.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-hidden', 'true');
        }

        function toggleMenu() {
            if (menu.classList.contains('show')) {
                closeMenu();
            } else {
                openMenu();
            }
        }

        // Clique no botão
        toggler.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation(); // evita fechar imediatamente
            toggleMenu();
        });

        menu.addEventListener('click', function (e) {
            e.stopPropagation();
        });

        document.addEventListener('click', function () {
            if (menu.classList.contains('show')) {
                closeMenu();
            }
        });
    }

    function showMenuProducts(clickedItem) {
        const titleCopy = document.getElementById('categoryTitleCopy');

        if (!clickedItem) return;

        const categoryTitle = clickedItem.getAttribute('data-category-title');

        if (titleCopy && categoryTitle) {
            titleCopy.textContent = categoryTitle;
        }

        toggleMenuScreens();
    }

    function changeProductTitleMobile(item) {
        const titleCopy = document.getElementById('categoryTitleCopyMobile');

        if (!item) return;

        const categoryTitle = item.getAttribute('data-category-title');

        if (titleCopy && categoryTitle) {
            titleCopy.textContent = categoryTitle;
        }
    }

    function toggleMenuScreens() {
        const categoriesScreen = document.getElementById('categories');
        const productsScreen = document.getElementById('products');

        categoriesScreen.classList.toggle('d-none');
        productsScreen.classList.toggle('d-none');
    }

    // volta explícita (sem toggle) para não depender do estado atual das telas
    function showMenuCategories() {
        const categoriesScreen = document.getElementById('categories');
        const productsScreen = document.getElementById('products');

        categoriesScreen.classList.remove('d-none');
        productsScreen.classList.add('d-none');
    }

    function handleLanguagesDropdown() {
        const languagesDropdown = document.getElementById('dropdownLanguages');
        const toggler = languagesDropdown.querySelector('.dropdown-toggle span');
        const items = languagesDropdown.querySelectorAll('.dropdown-item');

        items.forEach(item => {
            item.addEventListener('click', () => {
                const icon = item.querySelector('span');

                const newClasses = icon.className;
                const currentClasses = toggler.className;

                if (newClasses !== currentClasses) {
                    toggler.className = newClasses;
                }
            });
        });
    }

    function changeMenuInnerPages() {
        const header = document.getElementById('header');
        const pageHome = document.getElementById('home');
        const page404 = document.getElementById('page404');

        if (!pageHome && !page404) {            
            changeMenuLogos('dark');
            
            header.classList.add('header-colored');
            header.classList.add('header-sticky')
        } else {
            header.classList.add('header-fixed')
        }
    }

    function changeMenuLogos(state) {
        let logoLight = document.querySelector('.logo-light');
        let logoDark = document.querySelector('.logo-colored');
        
        if (state == 'light') {
            logoLight.classList.remove('hidden');
            logoDark.classList.add('hidden');
        } else if (state == 'dark') {
            logoLight.classList.add('hidden');
            logoDark.classList.remove('hidden');
        } else {
            console.warn('erro de parâmetro')
        }

    }

    function handleMenuOnScroll() {
        const menu = document.getElementById('header');
        let lastScroll = window.pageYOffset || document.documentElement.scrollTop;

        function updateMenu() {
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

            // com o menu mobile aberto o header não reage ao scroll:
            // 'scrolled-down' esconderia o header (e o toggler) enquanto o menu está aberto.
            // lastScroll não é atualizado: com o body fixo o scrollY vira 0, e usar esse
            // valor faria o header se esconder ao fechar o menu (restauração > 0)
            if (document.documentElement.classList.contains('menu-mobile-open')) {
                return;
            }

            // evita comportamento negativo em iOS
            if (currentScroll <= 0) {
                menu.classList.remove('scrolled-up', 'scrolled-down');
            }

            if (currentScroll <= 1) {
                menu.classList.remove('header-scrolled');

                if (document.getElementById('home') || document.getElementById('page404')) {
                    menu.classList.remove('header-colored');
                    changeMenuLogos('light');
                }
            } else {
                menu.classList.add('header-scrolled');

                if (document.getElementById('home') || document.getElementById('page404')) {
                    menu.classList.add('header-colored');
                    changeMenuLogos('dark');
                }
            }

            if (currentScroll > lastScroll) {
                // scroll para baixo
                menu.classList.remove('scrolled-up');
                menu.classList.add('scrolled-down');
            } else {
                // scroll para cima
                menu.classList.remove('scrolled-down');
                menu.classList.add('scrolled-up');
            }

            lastScroll = currentScroll;
        }

        window.addEventListener('DOMContentLoaded', updateMenu);
        window.addEventListener('scroll', updateMenu);
    }

    // posição do scroll no momento em que o menu abriu (restaurada ao fechar)
    let lockedScrollY = 0;

    function lockPageScroll() {
        // a troca entre offcanvas dispara show de novo: sem o guard, lockedScrollY
        // seria recapturado como 0 (body já fixo) e a posição se perderia ao fechar
        if (document.documentElement.classList.contains('menu-mobile-open')) {
            return;
        }

        lockedScrollY = window.scrollY;

        // overflow:hidden sozinho não impede o scroll por toque no iOS/Safari;
        // o CSS também fixa o body, e o top compensa a posição da página
        document.documentElement.classList.add('menu-mobile-open');
        document.body.style.top = `-${lockedScrollY}px`;
    }

    function unlockPageScroll() {
        document.documentElement.classList.remove('menu-mobile-open');
        document.body.style.top = '';
        window.scrollTo(0, lockedScrollY);
    }

    function handleMenuMobile() {
        const toggler = document.getElementById('menuMobileToggler');
        const offcanvasElements = document.querySelectorAll('.offcanvas');

        // o hambúrguer é controlado 100% aqui (o botão não tem data-bs-toggle):
        // com data-api, tocar no hambúrguer com um submenu aberto reabria o
        // #menuMobile em vez de fechar tudo. '.showing' cobre offcanvas em transição.
        toggler.addEventListener('click', function () {
            const open = document.querySelector('.offcanvas.show, .offcanvas.showing');

            if (open) {
                bootstrap.Offcanvas.getOrCreateInstance(open).hide();
                toggler.setAttribute('aria-expanded', 'false');
            } else {
                bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('menuMobile')).show();
                toggler.setAttribute('aria-expanded', 'true');
            }
        });

        offcanvasElements.forEach(offcanvas => {
            offcanvas.addEventListener('show.bs.offcanvas', function () {
                toggler.classList.add('active');

                // trava o scroll da página (mesmo comportamento da home)
                lockPageScroll();
            });

            offcanvas.addEventListener('hidden.bs.offcanvas', function () {
                // ainda existe algum offcanvas aberto ou abrindo?
                // ('.showing' cobre a troca entre offcanvas: o hidden de um dispara
                // enquanto o próximo ainda está em transição, antes de ganhar '.show')
                const anyOpen = document.querySelector('.offcanvas.show, .offcanvas.showing');

                if (!anyOpen) {
                    toggler.classList.remove('active');
                    unlockPageScroll();
                }
            });
        });
    }

    function ajustMenuCategoriesDisplay() {
        const menuCategoriesMobile = document.getElementById('menuCategoriesMobile');

        const categories = menuCategoriesMobile.querySelectorAll('.product-item');
        const container = menuCategoriesMobile.querySelector('.offcanvas-body');
        
        if (categories.length > 3) {
            container.style.alignItems = 'start';
        }
    }

    // toggle whatsapp btn
    const whatsappBtn = document.getElementById('whatsapp');
    const footer = document.getElementById('footer');

    let footerVisible = false;

    function toggleWhatsappBtn() {
        if (window.scrollY >= 150 && !footerVisible) {
            whatsappBtn.classList.add('show');
        } else {
            whatsappBtn.classList.remove('show');
        }
    }

    const footerObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                footerVisible = entry.isIntersecting;
                toggleWhatsappBtn();
            });
        },
        {
            threshold: 0.2
        }
    );

    footerObserver.observe(footer);

    // swiper menu
    const swiperMenuProducts = new Swiper('.swiper-menu-products', {
        slidesPerView: 1,
        speed: 1000,
        spaceBetween: 32,
        grabCursor: true,
        
        breakpoints: {
            992: {
                slidesPerView: 3,
            }
        }
    })
}